import { createContext } from 'react'
import { RegisterState } from './Register.types'
import { RegisterVariants } from '../../services/types'

const initialState: RegisterState = {
  variant: '',
  types: [],
  cities: [],
  genres: [],
  demAges: [],
  statuses: [],
  demSexes: [],
  warnings: [],
  ageRanges: [],
  countries: [],
  departments: [],
  distributions: [],
  auxTeam: [],
  auxGenres: [],
  series: [],
  authors: [],
  publishers: [],
  publications: [],
  updateVariant: (v: RegisterVariants) => Promise.resolve(),
  updateTypes: () => Promise.resolve(),
  updateGenres: () => Promise.resolve(),
  updateCities: () => Promise.resolve(),
  updateDemAges: () => Promise.resolve(),
  updateDemSexes: () => Promise.resolve(),
  updateStatuses: () => Promise.resolve(),
  updateWarnings: () => Promise.resolve(),
  updateAgeRanges: () => Promise.resolve(),
  updateCountries: () => Promise.resolve(),
  updateDepartments: () => Promise.resolve(),
  updateDistributions: () => Promise.resolve(),
  updateAuxTeam: () => Promise.resolve(),
  updateAuxGenre: () => Promise.resolve(),
  updateSeries: () => Promise.resolve(),
  updateAuthors: () => Promise.resolve(),
  updatePublishers: () => Promise.resolve(),
  updatePublications: () => Promise.resolve(),
}

const RegisterContext = createContext<RegisterState>(initialState)

export default RegisterContext
